import { useMedicalServiceMedicalMultiplePeriodsList } from '@insurance/api/queries'
import { Select, SelectProps } from 'antd'
import { useTranslation } from 'react-i18next'

export const MultipleDaysSelect = (props: SelectProps) => {
  const { t } = useTranslation()
  const { data, isLoading } = useMedicalServiceMedicalMultiplePeriodsList({})

  return (
    <Select
      loading={isLoading}
      options={data?.map(({ days }) => ({
        label: t('days_count', { count: days }),
        value: days
      }))}
      {...props}
    />
  )
}
